import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2cf9a2d0"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["hidden"]
const _hoisted_2 = { id: "inner-container" }
const _hoisted_3 = { id: "top" }
const _hoisted_4 = { id: "top-span" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  id: "close-button",
  class: "close"
}, "×", -1))
const _hoisted_6 = ["hidden"]
const _hoisted_7 = { id: "bottom-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    id: "tool-container",
    hidden: _ctx.toolHidden,
    style: _normalizeStyle({
      top: _ctx.topPosition + 'px',
      left: _ctx.leftPosition + 'px',
      width: _ctx.width + 'px',
      height: _ctx.height + 'px',
      zIndex: _ctx.zIndex,
    }),
    onMousedown: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toolSelected && _ctx.toolSelected(...args))),
    onTouchstart: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toolSelected && _ctx.toolSelected(...args)))
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.title), 1),
        _hoisted_5
      ]),
      _createElementVNode("div", {
        id: "middle",
        style: _normalizeStyle({ marginBottom: _ctx.bottomMarginSize + 'px' })
      }, [
        _renderSlot(_ctx.$slots, "default", {}, undefined, true)
      ], 4),
      _createElementVNode("div", {
        id: "bottom",
        hidden: !_ctx.showFooter
      }, [
        _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.bottomText), 1)
      ], 8, _hoisted_6)
    ])
  ], 44, _hoisted_1))
}